import React from 'react';
import './Button.scss';

const Button = (props, ref) => {
    const classes = "Button " + props.className;
    const onClick = props.onClick;

    return (
        <button ref={ref} className={classes} onClick={onClick}>
            {props.content}
            {props.children}
        </button>
    );
}

const forwardRefButton = React.forwardRef(Button)
export default forwardRefButton;
